import { render } from "./ProductBox.vue?vue&type=template&id=641d2266&scoped=true"
import script from "./ProductBox.vue?vue&type=script&lang=js"
export * from "./ProductBox.vue?vue&type=script&lang=js"

import "./ProductBox.vue?vue&type=style&index=0&id=641d2266&scoped=true&lang=css"

import exportComponent from "/home/user/WebstormProjects/ynamly_vue-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641d2266"]])

export default __exports__